import React from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";

const OrderList = ({ value }) => {
  const nav = useNavigate();

  const handleClick = () => {
    localStorage.setItem("item", JSON.stringify(value));
    nav("/active-order-detail", {
      state: {
        item: value,
      },
    });
  };

  return (
    <div className="a-order-list" onClick={handleClick}>
      <div className="a-name-img">
        <div className="a-img-container">
          <img
            style={{
              width: "100%",
              borderRadius: "50%",
            }}
            src="zmall-logo.png"
            alt="logo"
          />
        </div>
        <div className="a-name-description">
          <p>{value.store_name}</p>
          {/* <p>Order No. #{value.order_details[0].unique_id}</p> */}
          <p>Order No. #{value.unique_id}</p>
          <p>{value.created_at}</p>
          <p
            style={{
              color: "var(--primary-color)",
            }}
          >
            {value.order_status == 1 && "Waiting for store to accept"}
          </p>
          <p
            style={{
              color: "var(--primary-color)",
            }}
          >
            {value.order_status == 25 && "Order completed"}
          </p>
        </div>
      </div>
      <div className="a-price">
        <p>
          {value.currency} {value.total_order_price}
        </p>
      </div>
    </div>
  );
};

export default OrderList;
